module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f431f212115f8db3704038ea01ea09e.png";